/*
  avanzio — bolinhas de cor do card de produto

  Cada bolinha carrega a foto da variante (data-img / data-srcset), a foto
  de hover daquela cor (data-hover) e o link já com ?variant=. Clicar troca
  a foto, o hover e o destino do card — sem sair da página.

  Um listener só, delegado no documento: cobre cards que entram depois
  (carrossel, filtro de coleção, editor de tema).
*/
(function () {
  if (window.__avCardSwatch) return;
  window.__avCardSwatch = true;

  function escolher(botao) {
    var card = botao.closest('.av-card');
    if (!card) return;

    var principal = card.querySelector('[data-card-img]');
    var hover = card.querySelector('[data-card-hover]');

    if (principal && botao.dataset.img) {
      principal.srcset = botao.dataset.srcset || '';
      principal.src = botao.dataset.img;
    }

    if (hover) {
      if (botao.dataset.hover) {
        hover.srcset = '';
        hover.src = botao.dataset.hover;
        hover.hidden = false;
      } else {
        // Sem segunda foto desta cor: melhor nenhum hover do que o de outra cor.
        hover.hidden = true;
      }
    }

    if (botao.dataset.url) {
      card.querySelectorAll('[data-card-link]').forEach(function (a) {
        a.href = botao.dataset.url;
      });
    }

    card.querySelectorAll('[data-card-swatch]').forEach(function (b) {
      var ativo = b === botao;
      b.classList.toggle('is-selected', ativo);
      b.setAttribute('aria-pressed', ativo ? 'true' : 'false');
    });
  }

  document.addEventListener('click', function (e) {
    var botao = e.target && e.target.closest ? e.target.closest('[data-card-swatch]') : null;
    if (!botao) return;
    e.preventDefault();
    escolher(botao);
  });
})();
